import {
  startLoading,
  receivedGetFleetSettingsSuccess,
  receivedGetFleetSettingsFail,
  receivedUpdateFleetSettingsSuccess,
  receivedUpdateFleetSettingsFail,
  receivedFleetSettingsAlertsSuccess,
  receivedFleetSettingsAlertsFail,
  receivedUpdatedFleetSettingsAlertsSuccess,
  receivedUpdatedFleetSettingsAlertsFail,
  receivedTermsAndConditionsSuccess,
  receivedTermsAndConditionsFail,
  receivedCreatedTermsAndConditionsSuccess,
  receivedCreatedTermsAndConditionsFail,
  receivedUpdatedTermsAndConditionsSuccess,
  receivedUpdatedTermsAndConditionsFail,
  receivedChargesSuccess,
  receivedChargesFail,
  receivedClearCharges,
  receivedDefaultChargesSuccess,
  receivedDefaultChargesFail,
  receivedAddChargeSuccess,
  receivedAddChargeFail,
  receivedDeleteChargeSuccess,
  receivedDeleteChargeFail,
  receivedTaxesSuccess,
  receivedTaxesFail,
  receivedAddTaxSuccess,
  receivedAddTaxFail,
  receivedUpdateTaxSuccess,
  receivedUpdateTaxFail,
  receivedDeleteTaxSuccess,
  receivedDeleteTaxFail,
  receivedEditChargeSuccess,
  receivedEditChargeFail,
  receivedChargeSuccess,
  recievedChargeFail,
  receivedDevicesSuccess,
  receivedDevicesFail,
  receivedDisconnectDeviceSuccess,
  receivedDisconnectDeviceFail,
} from './actions';

import {
  settings,
  patchSettings,
  patchAlerts,
  termsAndConditions,
  postTermsAndConditions,
  patchTermsAndConditions,
  charges,
  charge,
  saveCharge,
  updateCharge,
  deleteCharge,
  requestDefaultCharges,
  taxes,
  saveTax,
  deleteTax,
  patchTax,
  devices,
  requestDisconnectDevice,
  deviceForceVin,
} from './resources';

import { sanitizeAlerts } from './FleetSettingsService.sanitizers';
import { DefaultCharge, DefaultChargeCreation, FleetSettings } from 'services/resources';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';
import { AnyAction } from 'redux';

/**
 * Gets the fleet settings alerts
 */
export const getAlerts = () => (dispatch) => {
  dispatch(startLoading());

  return settings()
    .then((response) => {
      dispatch(receivedFleetSettingsAlertsSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedFleetSettingsAlertsFail(response.data));
    });
};

/**
 * Gets the fleet settings alerts
 */
export const updateAlerts = (id, fleetSettingsAlerts) => (dispatch) => {
  dispatch(startLoading());

  const sanitizedAlerts = sanitizeAlerts(fleetSettingsAlerts);

  return patchAlerts(id, sanitizedAlerts)
    .then((response) => {
      dispatch(receivedUpdatedFleetSettingsAlertsSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedUpdatedFleetSettingsAlertsFail(response.data));

      return Promise.reject();
    });
};

/**
 * Gets the dealer charges
 */
export const getCharges = () => (dispatch) => {
  dispatch(startLoading());

  return charges()
    .then((response) => {
      dispatch(receivedChargesSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedChargesFail(response.data));
    });
};

export const getChargeById = (id: number) => (dispatch) => {
  dispatch(startLoading());

  return charge(id)
    .then((response) => {
      dispatch(receivedChargeSuccess(response));
    })
    .catch((response) => {
      dispatch(recievedChargeFail(response.data));
    });
};

export const getDefaultCharges = () => (dispatch) => {
  dispatch(startLoading());

  return requestDefaultCharges()
    .then((response) => {
      dispatch(receivedDefaultChargesSuccess(response));
      return response;
    })
    .catch((response) => {
      dispatch(receivedDefaultChargesFail(response.data));
    });
};

export const clearCharges = () => (dispatch) => {
  dispatch(receivedClearCharges());
};

/**
 * Adds a new charge
 */
export const addCharge = (charge: DefaultChargeCreation) => (dispatch) => {
  dispatch(startLoading());

  return saveCharge(charge)
    .then((response) => {
      dispatch(receivedAddChargeSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedAddChargeFail(response.data));

      return Promise.reject();
    });
};

/**
 * Updates an existing charge
 */
export const editCharge = (id: number, charge: DefaultChargeCreation, actingAs: number | null) => (dispatch) => {
  dispatch(startLoading());
  return updateCharge(id, charge, actingAs)
    .then((response) => {
      dispatch(receivedEditChargeSuccess(response.id, response));
    })
    .catch((response) => {
      dispatch(receivedEditChargeFail(response.data));

      return Promise.reject();
    });
};

/**
 * Deletes a charge
 */
export const removeCharge = (id: number, actingAs: number | null) => (dispatch) => {
  return deleteCharge(id, actingAs)
    .then(() => {
      dispatch(receivedDeleteChargeSuccess(id));
    })
    .catch((response) => {
      dispatch(receivedDeleteChargeFail(response.data));

      return Promise.reject();
    });
};

/**
 * Gets the dealer taxes
 */
export const getTaxes = () => (dispatch) => {
  dispatch(startLoading());

  return taxes()
    .then((response) => {
      dispatch(receivedTaxesSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedTaxesFail(response.data));
    });
};

/**
 * Adds a new tax
 */
export const addTax = (tax) => (dispatch) => {
  dispatch(startLoading());

  return saveTax(tax)
    .then((response) => {
      dispatch(receivedAddTaxSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedAddTaxFail(response.data));

      return Promise.reject();
    });
};

export const updateTax = (tax) => (dispatch) => {
  dispatch(startLoading());

  return patchTax(tax)
    .then((response) => {
      dispatch(receivedUpdateTaxSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedUpdateTaxFail(response.data));

      return Promise.reject();
    });
};

/**
 * Deletes a tax
 */
export const removeTax = (id) => (dispatch) => {
  dispatch(startLoading());

  return deleteTax(id)
    .then(() => {
      dispatch(receivedDeleteTaxSuccess(id));
    })
    .catch((response) => {
      dispatch(receivedDeleteTaxFail(response.data));

      return Promise.reject();
    });
};

export const getTermsAndConditions = () => (dispatch) => {
  dispatch(startLoading());

  return termsAndConditions()
    .then((response) => {
      // @ts-expect-error TS(2339): Property 'results' does not exist on type '{... Remove this comment to see the full error message
      if (response.results.length) {
        // @ts-expect-error TS(2339): Property 'results' does not exist on type '{... Remove this comment to see the full error message
        dispatch(receivedTermsAndConditionsSuccess(response.results[0]));
      }
    })
    .catch((response) => {
      dispatch(receivedTermsAndConditionsFail(response.data));
    });
};

export const createTermsAndConditions = (dealershipId, name, text) => (dispatch) => {
  dispatch(startLoading());

  return postTermsAndConditions(dealershipId, name, text)
    .then((response) => {
      dispatch(receivedCreatedTermsAndConditionsSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedCreatedTermsAndConditionsFail(response.data));
    });
};

export const updateTermsAndConditions = (id, dealershipId, name, text) => (dispatch) => {
  dispatch(startLoading());

  return patchTermsAndConditions(id, dealershipId, name, text)
    .then((response) => {
      dispatch(receivedUpdatedTermsAndConditionsSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedUpdatedTermsAndConditionsFail(response.data));
    });
};

export const getFleetSettings = (): ThunkAction<Promise<void>, RootState, unknown, AnyAction> => (dispatch) => {
  dispatch(startLoading());

  return settings()
    .then((response) => {
      dispatch(receivedGetFleetSettingsSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedGetFleetSettingsFail(response.data));
    });
};

export const updateSettings =
  (id: number, fleetSettings: Partial<FleetSettings>): ThunkAction<Promise<void>, RootState, unknown, AnyAction> =>
  (dispatch) => {
    dispatch(startLoading());

    return patchSettings(id, fleetSettings)
      .then((response) => {
        dispatch(receivedUpdateFleetSettingsSuccess(response));
      })
      .catch((response) => {
        dispatch(receivedUpdateFleetSettingsFail(response.data));
      });
  };

/**
 * Gets the Munic Devices
 */
export const getDevices = () => (dispatch) => {
  dispatch(startLoading());

  return devices()
    .then((response) => {
      dispatch(receivedDevicesSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedDevicesFail(response.data));
    });
};

export const disconnectDevice = (deviceId: number) => (dispatch) => {
  dispatch(startLoading());

  return requestDisconnectDevice(deviceId)
    .then((response) => {
      dispatch(receivedDisconnectDeviceSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedDisconnectDeviceFail(response.data));
    });
};

export const forceVin = (id: number, vin: string) => (dispatch) => {
  dispatch(startLoading());

  return deviceForceVin(id, vin)
    .then(() => {
      dispatch(getDevices());
    })
    .catch((response) => {
      dispatch(receivedDevicesFail(response.data));
    });
};
